module.exports = __webpack_public_path__ + "static/media/electro.11a766ee.jpg";